import React, { useState } from 'react';
import "../../style/components/formInitiators.css"

// Email Input Component
export const EmailInput = ({ value, onChange }) => {
  const [error, setError] = useState('');

  // Real-time email validation check
  const handleInputChange = (e) => {
    const email = e.target.value;

    // Allow updating the email value
    onChange({ target: { name: 'email', value: email } });

    // Validate email ends with @gmail.com
    if (email && !email.endsWith('@gmail.com')) {
      setError('Email must end with @gmail.com');
    } else {
      setError('');
    }
  };

  return (
    <div>
      <label htmlFor="email">Email ID:</label>
      <input
        type="text"
        id="email"
        name="email"
        value={value || ''}
        onChange={handleInputChange}
        style={{
          border: error ? '2px solid red' : '1px solid #ccc',  // Red border if error
        }}
      />
      {error && (
        <div
          style={{
            backgroundColor: '#f8d7da',
            color: '#721c24',
            padding: '5px 10px',
            borderRadius: '4px',
            fontSize: '12px',
            marginTop: '5px', // Info box displayed below input
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
};

// Radio Button Input Component
export const RadioButtonInput = ({ value, onChange, name, options, orientation }) => {
  return (
    <div className={`google_forms radio-group ${orientation === 'vertical' ? 'flex-col' : 'flex-row'}`}>
      {options.map(({ value: optionValue, label }) => (
        <label key={optionValue} className="flex items-center space-x-2">
          <input
            type="radio"
            name={name}
            value={optionValue}
            checked={value === optionValue}
            onChange={() => onChange({ target: { name, value: optionValue } })}
            className="cursor-pointer"
          />
          <span>{label}</span>
        </label>
      ))}
    </div>
  );
};





// Phone Number Input Component
export const PhoneNumberInput = ({ value, onChange, name }) => {
  const [error, setError] = useState('');

  // Phone number validation for exactly 10 digits
  const phoneNumberRegex = /^\d{10}$/;

  const handleChange = (e) => {
    const phoneValue = e.target.value;
    onChange({ target: { name, value: phoneValue } });

    // Validate phone number (only 10 digits allowed)
    if (phoneValue && !phoneNumberRegex.test(phoneValue)) {
      setError('Phone number must be exactly 10 digits');
    } else {
      setError('');
    }
  };

  return (
    <div>
      <label htmlFor={name}>Phone Number</label>
      <input
        type="number"
        id={name}
        name={name}
        value={value}
        onChange={handleChange}
        placeholder="Enter 10-digit phone number"
        style={{
          border: error ? '2px solid red' : '1px solid #ccc',
        }}
      />
      {error && (
        <div
          style={{
            backgroundColor: '#f8d7da',
            color: '#721c24',
            padding: '5px 10px',
            borderRadius: '4px',
            fontSize: '12px',
            marginTop: '5px',
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
};



export const DropdownPayLevels = () => {
  const options = [
    "S-1", "S-2", "S-3", "S-4", "S-5", "S-6", "S-7", "S-8", "S-9", "S-10", "S-11", "S-12",
    "S-13", "S-14", "S-15", "S-16", "S-17", "S-18", "S-19", "S-20", "S-21", "S-22", "S-23", "S-24",
    "S-25", "S-26", "S-27", "S-28", "S-29", "S-30", "S-31",
    "AL-10", "AL-11", "AL-12", "AL-13A", "AL-14", "AL-15"
  ];

  return (
    <div className="flex flex-col items-start">
      <label htmlFor="levelDropdown" className="text-gray-700 font-medium mb-2">
        Select Level:
      </label>
      <select
        id="levelDropdown"
        className="w-64 p-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-accent-green focus:outline-none"
      >
        <option value="" disabled selected>
          -- Select an option --
        </option>
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
};



export const CheckboxInput = ({ value, onChange, name, label }) => {
  const handleChange = (e) => {
    // When the checkbox is clicked, update the value in formData
    onChange({ target: { name, value: e.target.checked } });
  };

  return (
    <div className="checkbox-container">
      <label htmlFor={name} className="checkbox-label">
        {label}
      </label>
      <input
        type="checkbox"
        id={name}
        name={name}
        checked={value}
        onChange={handleChange}
        className="checkbox-input"
      />
    </div>
  );
};



export default { EmailInput, RadioButtonInput, PhoneNumberInput, CheckboxInput };